import {Component, OnDestroy, OnInit} from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit, OnDestroy {

    ngOnInit(): void {

    }

    ngOnDestroy(): void {
        console.log()
    }
}
